module.exports = __webpack_public_path__ + "img/tiktok.92d23c9.svg";